module.exports = __webpack_public_path__ + "static/media/cards_thumb.0d724e7a.jpg";